module.exports = __webpack_public_path__ + "static/media/20240530090024_IMG_7493.fa23c2d7.JPG";